export interface UpdateCorporateRoleDto {
  name: string; // Required, max 100
  description?: string | null; // Max 500
  isActive?: boolean;
  isDefault?: boolean;
}
